'use client';
import React from 'react';
import {Box, Stack} from '@mui/material';
import cn from './style.module.scss';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import WaldorfLaunchContainer from '../WaldorfContainer';
export default function WaldorfDistinctive(props: any) {
  const {t} = props;
  return (
    <Box component='section' className={cn.waldorfDistinctive}>
      <Stack className={cn.distinctiveInner}>
        <WaldorfLaunchContainer>
          <Box className={cn.distinctiveContent}>
            <Box className={cn.distinctiveContent__heading}>
              <ParallaxText
                variant='h3'
                animationType='slideInBottom'
                animationDuration={800}>
                {ReactHtmlParser(t['waldorfDistinctiveHeading'])}
              </ParallaxText>
            </Box>
            <Box className={cn.distinctiveContent__text}>
              <ParallaxText
                variant='body1'
                animationType='slideInBottom'
                animationDuration={800}>
                {ReactHtmlParser(t['waldorfDistinctiveContent'])}
              </ParallaxText>
            </Box>
          </Box>
        </WaldorfLaunchContainer>
      </Stack>
    </Box>
  );
}
